export default "__VITE_ASSET__98446f30__"